var Sizes;

(function (Sizes) {
  Sizes["Small"] = "Small";
  Sizes["Medium"] = "Medium";
  Sizes["Large"] = "Large";
})(Sizes || (Sizes = {}));

var InteractionTypes;

(function (InteractionTypes) {
  InteractionTypes["ToggleClick"] = "ToggleClick";
  InteractionTypes["Controlled"] = "Controlled";
})(InteractionTypes || (InteractionTypes = {}));

var MenuAlignments;

(function (MenuAlignments) {
  MenuAlignments["TopLeft"] = "TopLeft";
  MenuAlignments["BottomLeft"] = "BottomLeft";
  MenuAlignments["TopRight"] = "TopRight";
  MenuAlignments["BottomRight"] = "BottomRight";
  MenuAlignments["RightTop"] = "RightTop";
  MenuAlignments["LeftTop"] = "LeftTop";
  MenuAlignments["RightBottom"] = "RightBottom";
  MenuAlignments["LeftBottom"] = "LeftBottom";
  MenuAlignments["TopCenter"] = "TopCenter";
  MenuAlignments["BottomCenter"] = "BottomCenter";
  MenuAlignments["RightCenter"] = "RightCenter";
  MenuAlignments["LeftCenter"] = "LeftCenter";
})(MenuAlignments || (MenuAlignments = {}));

var CaretDirection;

(function (CaretDirection) {
  CaretDirection["Up"] = "DIRECTION/UP";
  CaretDirection["Down"] = "DIRECTION/DOWN";
})(CaretDirection || (CaretDirection = {}));

var BoundariesElements;

(function (BoundariesElements) {
  BoundariesElements["Viewport"] = "viewport";
  BoundariesElements["Window"] = "window";
  BoundariesElements["ScrollParent"] = "scrollParent";
})(BoundariesElements || (BoundariesElements = {}));

var SelectTypes;

(function (SelectTypes) {
  SelectTypes["Checkbox"] = "Checkbox";
  SelectTypes["Radio"] = "Radio";
})(SelectTypes || (SelectTypes = {}));

var SelectPositions;

(function (SelectPositions) {
  SelectPositions["Leading"] = "Leading";
  SelectPositions["Trailing"] = "Trailing";
})(SelectPositions || (SelectPositions = {}));

var TitleAlignments;

(function (TitleAlignments) {
  TitleAlignments["Left"] = "Left";
  TitleAlignments["Center"] = "Center";
  TitleAlignments["Right"] = "Right";
})(TitleAlignments || (TitleAlignments = {}));

export { BoundariesElements, CaretDirection, InteractionTypes, MenuAlignments, SelectPositions, SelectTypes, Sizes, TitleAlignments };
